import { Component, inject, OnInit } from '@angular/core';
import { JwtUtil, NotificationStore,  } from '@ribera-web/token-decodifier-service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-notification-alert-ui',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './notification-alert-ui.html',
  styleUrl: './notification-alert-ui.scss',
})
export class NotificationAlertUi implements OnInit {
  private jwtUtil = inject(JwtUtil);
  private notificationStore = inject(NotificationStore);

  annualRewardsAchieved: any | null;
  annualRewardsNearlyAchieved: any | null;
  
  ngOnInit(): void {
    this.notificationStore.notifications$.subscribe(() => {
      this.loadNotifications();
    });

    this.loadNotifications();
  }
  
  private loadNotifications() {
    const notifications = this.notificationStore.get();
    const userData = this.jwtUtil.getUserFromToken(localStorage.getItem('accessToken') || '');
    const currentUserId = userData.userId ?? userData.id;

    if (notifications && userData.is_user_inclub && notifications.userId == currentUserId) {
      this.annualRewardsAchieved = notifications.items.find((i: any) => i.code === "ANNUAL_REWARDS_ACHIEVED") ?? null;
      this.annualRewardsNearlyAchieved = notifications.items.find((i: any) => i.code === "ANNUAL_REWARDS_NEARLY_ACHIEVED") ?? null;
    }
  }
  
  getPortfolios(portfolios: number[]): string {
    const names = portfolios.map((item: any) => this.getPortfolioName(item.id));

    if (names.length === 0) return '';
    if (names.length === 1) return names[0];
    if (names.length === 2) return `${names[0]} y ${names[1]}`;
    return `${names.slice(0, -1).join(', ')} y ${names[names.length - 1]}`;
  }
  
  getTimeAgo(date: string | Date): string {
    const now = new Date();
    const past = new Date(date);

    const diffMs = now.getTime() - past.getTime();

    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (seconds < 60) return `Hace ${seconds} segundos`;
    if (minutes < 60) return `Hace ${minutes} min`;
    if (hours < 24) return `Hace ${hours} horas`;
    return `Hace ${days} días`;
  }
  
  getPortfolioName(id: number): string {
    const portfolios: Record<number, string> = {
      1: 'INRESORTS LA JOYA',
      2: 'INRESORTS PLAYA HERMOSA TUMBES',
      3: 'INRESORTS RIBERA DEL RIO',
      7: 'INRESORTS CUSCO',
    };

    return portfolios[id] ?? '';
  }
}
